// extracted by mini-css-extract-plugin
export default {"bar":"ChatInput_bar__unEwG","wrap":"ChatInput_wrap__+fAZQ","ta":"ChatInput_ta__8SK9w","btn":"ChatInput_btn__AxkLp","off":"ChatInput_off__mldcB"};